import React, { useState } from 'react';
import { Icon, Input, Image, Table, TableHeader, TableRow, Header, Card, Button, Divider, Item } from 'semantic-ui-react';
import { RootState } from '../store/SrciStore';
import { useAppSelector } from '../store/hooks';
import products from "../data/Products"

export default function ProductsPage() {

  const [cart, setCart] = useState([products[0]]);
  const [total, setTotal] = useState(products[0].price)

  const addToCart = (product: any) => {
    setCart(current => [...current, product])
    setTotal(current => current + product.price)
  }

  const generalInput = useAppSelector((state: RootState) => state.srciInputData.generalInput)

  return (
    <React.Fragment>
      <Table size="small" compact="very">
        <TableHeader>
          <TableRow>
            <Table.HeaderCell>Product</Table.HeaderCell>
            <Table.HeaderCell>Price</Table.HeaderCell>
            <Table.HeaderCell>Quantity</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </TableRow>
        </TableHeader>
        <Table.Body>
          {cart.map((product, index) => 
          <Table.Row key={index}>
            <Table.Cell>
              <Item.Group>
              <Item>
                <Item.Image size="tiny" src={product.image} />
                <Item.Content>
                  <Item.Header>{product.header}</Item.Header>
                  <Item.Meta>{product.description}</Item.Meta>
                </Item.Content>
              </Item>
              </Item.Group>
            </Table.Cell>
            <Table.Cell>{product.price} {generalInput.currencyCode}</Table.Cell>
            <Table.Cell><Input type="number" value={1} fluid /></Table.Cell>
            <Table.Cell textAlign="center"><Icon name="trash alternate outline" color="red" /></Table.Cell>
          </Table.Row>         
          )}        
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.Cell textAlign="right"><Header as={"h3"}>Total:</Header></Table.Cell>
            <Table.Cell><Header as={"h3"}>{total} {generalInput.currencyCode}</Header></Table.Cell>
          </Table.Row>
        </Table.Footer>
      </Table>  

      <Header as="h3">Other products</Header>    

      <Card.Group centered itemsPerRow={4}>
        
        {products.sort(() => Math.random() - Math.random()).slice(0, 4).map((product, index) => 
        <Card key={index}>
          <Image src={product.image} wrapped ui={false} />
          <Card.Content>
            <Card.Header>{product.header}</Card.Header>
            <Card.Meta>{product.description}</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Button fluid animated="fade" onClick={() => addToCart(product)}>
              <Button.Content visible>{product.price} {generalInput.currencyCode}</Button.Content>
              <Button.Content hidden><Icon name='shop' /> Buy me!</Button.Content>
            </Button>
          </Card.Content>
        </Card>
        )}
      
      </Card.Group>
      <Divider hidden/>
    </React.Fragment>
  );
}